export enum ADD_FILE_OPTION_NAME {
  Email = 'Email',
  Pictures = 'Pictures',
  Files = 'Files',
  Dropbox = 'Dropbox',
  DropBox = 'DropBox',
  Drop_Box = 'Drop Box',
  Box = 'Box',
  Web = 'Web',
  Google_Drive = 'Google Drive',
  GoogleDrive = 'GoogleDrive',
  OneDrive = 'OneDrive',
  One_Drive = 'One Drive',
  One_drive = 'One drive',
  Office_365 = 'Office 365',
  Office365 = 'Office365',
}

export enum EMAIl_PROVIDER {
  hotmail = 'hotmail',
  outlook = 'outlook',
  office = 'office',
  google = 'google',
  imap = 'imap',
}

export enum CUSTOMER_TYPE {
  tbs = 'tbs',
}

export enum CLOUD_FILE_TYPE {
  folder = 'folder',
  file = 'file',
}

export enum CLOUD_LOGIN_PROVIDER {
  box = 'box',
  dropbox = 'dropbox',
  onedrive = 'onedrive',
}

export enum ICON_PATH_KEY {
  folder = 'folder',
  type = 'type',
  tag = '.tag',
}

export enum EMAIL_POPUP {
  emailPrinting = 'emailPrinting',
  nonTbsEmailPrinting = 'nonTbs-email-printing',
  nonTbsAliasEmailPrinting = 'nonTbs-alias-email-printing',
}

export enum EMAIL_ACCOUNT_TYPE {
  gmail = 'gmail',
  iCloud = 'iCloud',
  yahoo = 'yahoo',
  aol = 'aol',
  other = 'other',
  office = 'office',
  outlook = 'outlook',
  hotmail = 'hotmail',
  box = 'box',
  dropbox = 'dropbox',
  onedrive = 'onedrive',
  office365 = 'office365',
}

export enum MAP_SEGMENT_TYPE {
  nearest = 'nearest',
  map = 'map',
}

export enum ACCOUNT_LOGIN_PLATFORM {
  native = 'native',
  web = 'web',
}